import { cn } from '@/lib/utils'
import React from 'react'
import { lineSpinner } from 'ldrs'

lineSpinner.register()

export interface SpinnerProps extends React.HTMLAttributes<HTMLElement> {
  size?: string
  speed?: string
  color?: string
}

const Spinner = React.forwardRef<HTMLElement, SpinnerProps>(
  ({ size = '24', speed = '1.3', color = 'gray', className, ...props }, ref) => {
    return React.createElement('l-line-spinner', {
      ref,
      size,
      speed,
      color,
      className: cn(className),
      ...props
    })
  }
)

Spinner.displayName = 'Spinner'

export { Spinner } 